import './index.css';
import '@aws-amplify/ui-react/styles.css';

import { StrictMode } from "react";
import { Amplify } from 'aws-amplify';

import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './amplifyconfiguration.json';

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

reportWebVitals();